import type { Config } from "./default"

export default {
  mode: "tunnel",
  name: "Incmix TUNNEL",
  frontendUrl: "https://localhost:3000",
  backendUrl: "http://mixc.in.ngrok.io",
} as Config
